<style lang="scss">
@import "core";

#pg-app {
  margin-bottom: 30px;

  .pg-uni-bnr {
    color: $color-primary;
    line-height: 90px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .pg-linkto-search {
    margin-bottom: 20px;

    @include mq(pc) {
      width: 200px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "core";

#pg-app {
}

.my-offers {
}

.my-offer {
  background: #fff;
  border: solid 1px $color-divider;
  position: relative;
  z-index: 1;
  transform-style: preserve-3d;
  backface-visibility: hidden;

  &--moving {
  }

  & + &:not(.my-offer--moving) {
    border-top: 0;
  }

  &__header {
    display: flex;
    align-items: stretch;

    &-body {
      padding: 10px 10px 10px 20px;
      margin-right: auto;

      @include mq(sp) {
        padding-left: 10px;
      }
    }

    &-rank {
/*
      color: $color-primary;
*/
      font-size: 16px;
      font-weight: bold;
      padding-top: 5px;
      padding-bottom: 5px;
    }


    &-action {
      @include btn-base($display: flex);
      width: 44px;
      align-items: center;
      justify-content: center;
      border-left: solid 1px $color-divider;
      transition: background-color .25s;
      display: -ms-flexbox;

      &.is-disabled {
        cursor: default;
        pointer-events: none;
      }

      &:not(.is-disabled) {
        &:hover,
        &:focus {
          background: #fafafa;
        }

        &:active {
          background: #efefef;
        }
      }
    }
  }

  &__body {
    padding: 20px;
    border-top: solid 1px $color-divider;

    @include mq(sp) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  &__university-name {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    margin: 0 0 10px;
  }

  &__meta {

    &-list {
      border-bottom: solid 2px $color-primary;
      padding-bottom: 8px;
    }

    display: inline-block;

    &:not(:first-child) {
      margin-left: 1em;
    }
  }

  &__links {
    letter-spacing: 4em;
  }

  &__link {
    display: inline-block;
    vertical-align: middle;
    margin-top: 10px;
    letter-spacing: normal;
  }

  &__missing-notice {
    font-weight: bold;
    color: $color-strong;
  }
}

.my-wrap {
  display: inline-block;
}
.gaibu-link {
  text-decoration: underline;
}
</style>


<template>
  <div id="pg-app">
    <template v-if="$store.getters['config/isManabi']">
    <dn-db-downloader
      class="mb20"
      ref="downloader"
      target="@offers"
      v-model="downloadStatus"
      @data-ready="onDataReady"
      @download="onDownload"
    />

    <!-- データがある時（更新有り時も含む） -->
    <div v-if="hasData">
      <div v-if="!needFetch">
        <div v-if="isEmpty">
          <p style="margin-bottom: 120px;">現在登録はありません。「<a href="../search/index.html">志望校を検索・登録する</a>」からご登録ください。</p>
        </div>
        <div v-else>

          <p class="mb15">※出願の際には、各大学の最新の入試情報を確認してください。</p>

          <ul class="my-offers" v-if="linkReady">
            <li
              :id="`my-offer-${offer.id}`"
              v-for="(offer, index) in offers"
              :key="offer.id"
              class="my-offer"
              ref="offers"
            >
              <div class="my-offer__header">
                <div class="my-offer__header-body">
                  <span class="my-offer__header-rank">第{{index + 1}}志望</span>
                </div>
                <a title="1つ上へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isFirst}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'up')">
                  <dn-icon :class="{'is-disabled': offer.isFirst}" icon="tri-up" />
                </a>
                <a title="1つ下へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isLast}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'down')">
                  <dn-icon :class="{'is-disabled': offer.isLast}" icon="tri-down" />
                </a>
                <a title="削除" class="my-offer__header-action" href="javascript:void(0);" @click.stop="deleteOffer($event, offer)"><dn-icon icon="trash" /></a>
              </div>
              <div class="my-offer__body">
                <div v-if="offer.missing && !offer.university_name">
                  <p class="my-offer__missing-notice">募集単位に改組がありました。<wbr>選択し直してください。</p>
                </div>
                <div v-else>
                  <h3 class="my-offer__university-name">{{offer.university_name}}</h3>
                  <div class="my-offer__meta-list">
                    <p
                      v-for="key in displayItemDetailKeys"
                      v-if="offer[key]"
                      :key="key"
                      class="my-offer__meta"
                    >{{offer[key]}}</p>
                  </div>
                  <div v-if="offer.missing" style="padding-top:10px;">
                    <p class="my-offer__missing-notice">大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。<br>（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）</p>
                  </div>
                  <ul class="my-offer__links">
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`../../jikosaiten/hantei/index.html`" v-linkset="'C36'">判定{{$store.getters['config/isManabi'] ? 'を見る' : 'チェッカーで出願校を考える'}}</a>
                      <dn-icon icon="inspiration" />
                    </li>
                    <li class="my-offer__link">
                      <dn-icon icon="link" />
                      <a class="gaibu-link" :href="`https://manabi.benesse.ne.jp/daigaku/school/${offer.university_id}/nyushi/index.html`" target="_blank">最新の入試情報を見る</a>
                    </li>
                    <li class="my-offer__link">
                      <dn-icon icon="link" />
                      <a class="gaibu-link" :href="`https://manabi.benesse.ne.jp/daigaku/school/${offer.university_id}/index.html`" target="_blank">パンフ・願書を取り寄せる</a>
                    </li>

                    <!--
                      このリンクはいろんな経緯があって、
                      リンクIDやとジャンプ先がどんどん変更になっている（下部のコメントアウトされた「li」を参照）
                      今後の運用で取り扱い要注意！！
                    -->
                    <!--
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`../../../center/bible/exam/index.html`" v-linkset="'B11'">過去のセンター試験を解いて強化する科目・分野を把握する</a>
                      <dn-icon icon="inspiration" />
                    </li>
                    -->
                    <!--
                    <li v-if="useScore" class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`./score.html?offer_id=${offer.id}`" v-linkset="'B11'">志望大学合格までの距離を確認する<span>（1月16日まで公開）</span></a>
                      <dn-icon icon="inspiration" />
                    </li>
                    -->

                    <!--

                    -->
                    <li class="my-offer__link" v-if="!$store.getters['config/isManabi']">
                      <dn-icon icon="anchor" />
                      <a :href="`../../refresh/i_sum.html`" v-linkset="'C19'" target="_blank">インターネット選太君で出願校を考える</a>
                      <dn-icon icon="inspiration" />
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>

          <!--<div class="tar mt30" v-if="offers.length >= 1">
            <a is="dn-btn" class="pg-linkto-search dn-btn--plain dn-btn--block-sp" linkset="C36" href="https://dn-sundai.benesse.ne.jp/manabi/center/jikosaiten/hantei/index.html">合格可能性判定</a>
          </div>-->
          <div class="my-to-checker tar mt30" v-if="offers.length >= 1">
            <!--
            <a
              is="dn-btn"
              class="pg-linkto-search dn-btn--plain dn-btn--block-sp"
              @click="storeUnivList()"
              v-if="$store.getters['config/isManabi']">DB連携</a>
            -->
            <dn-btn
              class="my-to-checker__btn"
              accent
              href="../../jikosaiten/hantei/index.html"
              linkset="C36"
            >
              判定の確認{{$store.getters['config/isManabi'] ? '' : '　判定チェッカー'}}
            </dn-btn>
          </div>
        </div>

      </div>
    </div>
    </template>
    <template v-else>
    <dn-db-downloader
      class="mb20"
      ref="downloader"
      target="@offers"
      v-model="downloadStatus"
      @data-ready="onDataReady"
      @download="onDownload"
    />

    <!-- データがある時（更新有り時も含む） -->
    <div v-if="hasData">
      <div v-if="!needFetch">
        <div v-if="isEmpty">
          <p style="margin-bottom: 120px;">現在登録はありません。「<a href="../search/index.html">志望大学を検索・登録する</a>」からご登録ください。</p>
        </div>
        <div v-else>

          <p class="mb15">※出願の際には、各大学の最新の入試情報を確認してください。</p>

          <ul class="my-offers" v-if="linkReady">
            <li
              :id="`my-offer-${offer.id}`"
              v-for="(offer, index) in offers"
              :key="offer.id"
              class="my-offer"
              ref="offers"
            >
              <div class="my-offer__header">
                <div class="my-offer__header-body">
                  <span class="my-offer__header-rank">第{{index + 1}}志望</span>
                </div>
                <a title="1つ上へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isFirst}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'up')">
                  <dn-icon :class="{'is-disabled': offer.isFirst}" icon="tri-up" />
                </a>
                <a title="1つ下へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isLast}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'down')">
                  <dn-icon :class="{'is-disabled': offer.isLast}" icon="tri-down" />
                </a>
                <a title="削除" class="my-offer__header-action" href="javascript:void(0);" @click.stop="deleteOffer($event, offer)"><dn-icon icon="trash" /></a>
              </div>
              <div class="my-offer__body">
                <div v-if="offer.missing && !offer.university_name">
                  <p class="my-offer__missing-notice">募集単位に改組がありました。<wbr>選択し直してください。</p>
                </div>
                <div v-else>
                  <h3 class="my-offer__university-name">{{offer.university_name}}</h3>
                  <div class="my-offer__meta-list">
                    <p
                      v-for="key in displayItemDetailKeys"
                      v-if="offer[key]"
                      :key="key"
                      class="my-offer__meta"
                    >{{offer[key]}}</p>
                  </div>
                  <div v-if="offer.missing" style="padding-top:10px;">
                    <p class="my-offer__missing-notice">大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。<br>（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）</p>
                  </div>
                  <ul class="my-offer__links">
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`https://manabi.benesse.ne.jp/daigaku/school/${offer.university_id}/index.html`" target="_blank">パンフ・願書を取り寄せる</a>
                    </li>
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`https://manabi.benesse.ne.jp/daigaku/school/${offer.university_id}/nyushi/index.html`" target="_blank">最新の入試情報を見る</a>
                    </li>

                    <!--
                      このリンクはいろんな経緯があって、
                      リンクIDやとジャンプ先がどんどん変更になっている（下部のコメントアウトされた「li」を参照）
                      今後の運用で取り扱い要注意！！
                    -->
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`../../bible/exam/index.html`" v-linkset="'B3'">過去の共通テスト・センター試験を解いて強化する科目・分野を把握する</a>
                      <dn-icon icon="inspiration" />
                    </li>
                    <!--
                    <li v-if="useScore" class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`./score.html?offer_id=${offer.id}`" v-linkset="'B11'">志望大学合格までの距離を確認する<span>（1月16日まで公開）</span></a>
                      <dn-icon icon="inspiration" />
                    </li>
                    -->
                    <li class="my-offer__link">
                      <dn-icon icon="anchor" />
                      <a :href="`../../jikosaiten/hantei/index.html?offer=${index + 1}`" v-linkset="'C36'" target="_blank">判定{{$store.getters['config/isManabi'] ? 'を見て' : 'チェッカーで'}}出願校を考える</a>
                      <dn-icon icon="inspiration" />
                    </li>
                    <!--

                    -->
                    <li class="my-offer__link" v-if="!$store.getters['config/isManabi']">
                      <dn-icon icon="anchor" />
                      <a :href="`../../refresh/i_sum.html`" v-linkset="'C19'" target="_blank">インターネット選太君で出願校を考える</a>
                      <dn-icon icon="inspiration" />
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>

          <div class="tar mt30" v-if="offers.length >= 3">
            <a
              is="dn-btn"
              class="pg-linkto-search dn-btn--plain dn-btn--block-sp"
              @click="storeUnivList()"
              v-if="$store.getters['config/isManabi']">DB連携</a>
            <a is="dn-btn" class="pg-linkto-search dn-btn--plain dn-btn--block-sp" linkset="B6" href="../search/index.html">大学検索</a>
          </div>
        </div>

      </div>
    </div>
    </template>

  </div>
</template>



<script>

let _fetchRequestId = 0;
import PreferredUnivManager from 'models/PreferredUnivManager';

export default {
  name: 'dn-bible-myuniv-app',

  data() {
    return {

      // debug
      debug: this.$route.query.debug !== undefined,

      useScore: !this.$store.getters['config/isManabi'],

      // constants
      displayItemDetailKeys: [
        'faculty_name',
        'department_name',
        'schedule_name',
        'examination_method_name',
      ],

      // states
      state           : 'pending',
      fecthState      : 'pending',
      downloadStatus  : null,
      isAnimating     : false,
      hashJumped      : false,

      // values
      needFetch       : true,
      hits            : null,
      schoolChoices   : [],
      missings        : [],
    }
  },

  computed: {

    // refs
    $downloader() { return this.$refs.downloader },

    // flags
    hasData() { return this.downloadStatus ? this.downloadStatus.hasData : false },
    isEmpty() { return this.hits ? this.offers.length === 0 : false },
    isFetching() { return this.fecthState === 'fetching' },
    isFetched() { return this.fecthState === 'fetched' },
    hasFetchError() { return this.fecthState === 'error' },
    searchValues() { return {id: this.schoolChoices.map(id => id)} },
    kai() { return dn.$store.getters['config/kai'] },

    // values
    offers() {
      return this.schoolChoices.map((id, index) => {
        let hit = this.hits.hits.find(row => row.id === id);
        if (!hit) this.missings.push(id);
        // バージョンが最新でない場合改組
        if (hit && hit.version !== this.kai) {
          hit["missing"] = true;
          this.missings.push(id);
        }
        return Object.assign(
          {
            university_id: id.slice(0, 4),
            isFirst      : index === 0,
            isLast       : index === this.schoolChoices.length - 1,
          },
          hit ? hit : {id: id, missing: true}
        );
      });
    },

    linkReady() { return this.$store.getters['links/loaded'] },
    C2IsReady() { return this.$store.getters['links/enabled']('C39') || this.$store.getters['config/isManabi'] },
  },

  methods: {

    /**
     * ダウンロードが完了してフォームがマウントされてからの初期化処理
     */
    async init() {

      // ここでいったん初期表示用のデータをフェッチする
      await this.pushFetchQueue();

      this.state = 'ready';
    },



    /**
     * データをフェッチして変数に保持する
     */
    pushFetchQueue(condition = this.searchValues) {
      return new Promise((resolve, reject) => {
        const myQueue = {
          resolved: false,
          rejected: false,
          running : false,
          done    : false,
          hits    : null,
          error   : null,
        };

        const myIndex = this.fetchQueues.length;

        myQueue.trigger = () => {
          myQueue.running = true;

          const onDone = error => {
            myQueue.running = false;
            myQueue.done    = true;

            const nextQueue = this.fetchQueues[myIndex + 1];

            if (error) {
              reject(error);
            } else {
              resolve();
            }

            return nextQueue ? nextQueue.trigger() : this.onFinishFetchQueues();
          }

          dn.db.searchOffers(condition)
            .then(hits => {
              myQueue.resolved = true;
              myQueue.hits     = hits;
              return onDone();
            })
            .catch(error => {
              myQueue.rejected = true;
              myQueue.done     = true;
              myQueue.error    = error;
              return onDone(error);
            });
        }

        let hasBefore = false;
        if (myIndex > 0) {
          for (let i = 0; i < myIndex; i++) {
            if (this.fetchQueues[i].running || !this.fetchQueues[i].done) {
              hasBefore = true;
              break;
            }
          }
        }

        this.fetchQueues.push(myQueue);

        if (!hasBefore) {
          this.onStartFetchQueues();
          myQueue.trigger();
        }
      });
    },



    /**
     * フェッチキューの実行が開始した時のコールバック
     */
    onStartFetchQueues() {
      this.fecthState = 'fetching';
      dn.loading.show();
    },



    /**
     * フェッチキューの実行が全て完了した時のコールバック
     */
    onFinishFetchQueues() {
      dn.loading.hide();

      let hits;
      const errors = [];

      this.fetchQueues.forEach(queue => {
        if (queue.hits) hits = queue.hits;
        if (queue.error) errors.push(queue.error);
      });

      if (errors.length) {
        this.fecthState = 'error';
        throw new Error(errors);
      }

      if (hits) {
        this.missings = [];
        this.hits = hits;
      }

      this.needFetch = false;
      this.fecthState = 'fetched';
      this.tryFirstHashJumpToOffer();
    },



    /**
     * 初期フェッチ時のハッシュジャンプを試みる
     */
    tryFirstHashJumpToOffer() {
      if (this.hashJumped || !location.hash) {
        this.hashJumped = true;
        return;
      }

      this.hashJumped = true;
      const id = location.hash.replace(/^#my-offer-/, '');
      this.tryScrollToOffer(id);
    },



    /**
     * 指定のIDの志望校へのスクロールを試みる
     */
    tryScrollToOffer(id) {
      this.$nextTick(() => {
        const $offers = this.$refs.offers && this.$refs.offers.length ? this.$refs.offers : null;
        if (!$offers) return;

        const $offer = $offers.find($offer => $offer.id === `my-offer-${id}`);

        if (!$offer) return;
        this.$scrollTo($offer, 250);
      });
    },




    /**
     * 登録志望校更新時のコールバック
     */
    onChangeSchoolChoices() {
      const schoolChoices = dn.segments.schoolChoices.find();

      // すでにフェッチしているデータで足りていないかチェック
      let hasData = false;
      if (this.hits && this.hits.hits) {
        hasData = true;
        for (let id of schoolChoices) {
          if (!this.hits.hits.find(row => row.id === id) && !this.missings.includes(id)) {
            hasData = false;
            break;
          }
        }
      }

      if (!hasData) this.needFetch = true;

      this.$set(this, 'schoolChoices', schoolChoices);

      if (!hasData) this.pushFetchQueue();
    },



    /**
     * ダウンローダのデータの準備が出来た時のコールバック
     */
    onDataReady() {
      this.init();
    },



    /**
     * データのダウンロードが発生した後のコールバック
     */
    async onDownload() {
      await this.pushFetchQueue();
    },



    /**
     * 志望校DOMのアニメーションを伴う処理を行う時のメソッドラッパー
     * セグメントの監視を一回停止した上で非同期メソッドを行い
     * 完了したら元に戻す
     */
    async animateOfferFunction(promise) {
      if (this.isAnimating) return;

      this.isAnimating = true;
      this.stopWatchSchoolChoices();

      await promise();

      this.isAnimating = false;
      this.startWatchSchoolChoices();
      this.onChangeSchoolChoices();
    },



    /**
     * 志望校を削除する
     */
    async deleteOffer(e, offer) {
      if (!await dn.$confirm('削除しても宜しいですか？')) return false;
      await new Promise(resolve => { setTimeout(resolve, 150) });
      await this.animateOfferFunction(async () => {
        dn.segments.schoolChoices.remove(offer.id);

        const $offer = $(e.target).closest('.my-offer');
        if (this.$store.getters['config/isManabi']) {
          this.PreferredUnivManager.send();
        }

        await new Promise((resolve, reject) => {
          $offer.slideUp(350, resolve);
        });
      });
    },



    /**
     * 志望校の位置を移動する
     */
    async moveOffer(e, offer, vec) {
      await this.animateOfferFunction(async () => {
        dn.segments.schoolChoices.move(offer.id, vec);

        const $offer      = $(e.target).closest('.my-offer'),
              isDown      = vec === 'down',
              $pair       = $offer[isDown ? 'next' : 'prev'](),
              offerHeight = $offer.outerHeight(),
              pairHeight  = $pair.outerHeight(),
              duration    = 350,
              easing      = 'snap';

        $offer.addClass('my-offer--moving');
        $pair.addClass('my-offer--moving');

        const transition = `${duration}ms`;
        const transform = {
          offer: `translateY(${isDown ? pairHeight   : -pairHeight}px)`,
          pair : `translateY(${isDown ? -offerHeight : offerHeight}px)`,
        };
        const resetStyles = {
          'transform': '',
          '-webkit-transform': '',
          transition: '',
        };

        $offer.css({
          'transform': transform.offer,
          '-webkit-transform': transform.offer,
          transition,
        });
        $pair.css({
          'transform': transform.pair,
          '-webkit-transform': transform.pair,
          transition,
        });

        await new Promise(resolve => setTimeout(resolve, duration));
        $offer.css(resetStyles).removeClass('my-offer--moving');
        $pair.css(resetStyles).removeClass('my-offer--moving');
      });
      if (this.$store.getters['config/isManabi']) {
        this.PreferredUnivManager.send();
      }
    },



    /**
     * セグメントの監視を開始する
     */
    startWatchSchoolChoices() {
      dn.segments.schoolChoices.listen(() => {
        this.onChangeSchoolChoices();
      }, 'pg-bible-myuniv');
    },



    /**
     * セグメントの監視を停止する
     */
    stopWatchSchoolChoices() {
      dn.segments.schoolChoices.stopListen(undefined, 'pg-bible-myuniv');
    },

    /**
     * DBに志望校情報を保存
     */
    storeUnivList() {
      /* Cookie */
      let univList = dn.segments.schoolChoices.find();
      // let userType = dn.segments.userType.getId();
      if(!univList) { return; }

      fetch('', {
        method : 'POST',
        body : JSON.stringify(univList),
        headers : {
          'Content-Type' : 'application/json'
        }
      })
      .catch(error => {
        // dn.$alert('エラーが発生したため志望大をDB連携できませんでした。');
      });
    }
  },



  async created() {
    this.fetchQueues = [];
    this.PreferredUnivManager = new PreferredUnivManager();
  },



  async mounted() {
    await dn.segments.ready();
    this.startWatchSchoolChoices();
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?20ba53de